import { isValidElement } from 'react';

/** checkbox这类组件的props里，受控的值是checked而不是value */
export function isCheckedMap(v) {
  if (v == null || typeof v !== 'object') {
    return false;
  }
  /* eslint-disable no-underscore-dangle */


  return v.__ANT_SWITCH || v.__ANT_CHECKBOX; // eslint-enable no-underscore-dangle
}
export const commonMap = (opt, props) => {
  const {
    state,
    mutators
  } = opt;
  const {
    parse,
    format
  } = props;
  const res = {
    value: format == null ? state.value : format(state.value),

    /** 原始的mutators.change会取所有的入参，这里改成只取第一个 */
    onChange: v => {
      const val = parse == null ? v : parse(v);
      mutators.change(val);
    },
    onBlur: mutators.blur,
    onFocus: mutators.focus,
    ...state.props
  };

  if ( /*#__PURE__*/isValidElement(props.children)) {
    if (isCheckedMap(props.children.type)) {
      res.checked = res.value;
      delete res.value;
    }
  }

  return res;
};
//# sourceMappingURL=es/Other/Field/utils.js.map